export interface ZoomScrollInput {
  readonly scrollX: number;
  readonly scrollY: number;
  readonly viewportWidth: number;
  readonly viewportHeight: number;
  readonly screenX: number;
  readonly screenY: number;
  readonly zoom: number;
  readonly nextZoom: number;
}

export interface ZoomScroll {
  readonly scrollX: number;
  readonly scrollY: number;
}

export function calculateZoomScroll(input: ZoomScrollInput): ZoomScroll {
  const halfWidth = input.viewportWidth / 2;
  const halfHeight = input.viewportHeight / 2;
  const offsetX = input.screenX - halfWidth;
  const offsetY = input.screenY - halfHeight;
  const fixedWorldX = input.scrollX + halfWidth + offsetX / input.zoom;
  const fixedWorldY = input.scrollY + halfHeight + offsetY / input.zoom;

  return {
    scrollX: fixedWorldX - halfWidth - offsetX / input.nextZoom,
    scrollY: fixedWorldY - halfHeight - offsetY / input.nextZoom,
  };
}
